export const getFilenameFromResponse = (response) => {
  const contentDisposition = response.headers.get('Content-Disposition')
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/i)
    if (filenameMatch) {
      return filenameMatch[1]
    }
  }
  return 'download.zip'
}

export const fetchDownload = async (url) => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error('Download failed')
  }
  const blob = await response.blob()
  const filename = getFilenameFromResponse(response)
  return {blob, filename}
}

export const triggerBrowserDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  window.URL.revokeObjectURL(url)
  document.body.removeChild(link)
}
